import { Box } from "@mui/material";

interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  options?: {
    left: { value: string; label: string };
    right: { value: string; label: string };
  };
}

const TypeToggleButton = ({
  value,
  onChange,
  disabled = false,
  options = {
    left: { value: "util", label: "Util" },
    right: { value: "fixo", label: "Fixo" },
  },
}: Props) => {
  const isLeftSelected = value === options.left.value;

  return (
    <Box
      sx={{
        display: "flex",
        borderRadius: "7px",
        border: "1px solid",
        borderColor: "primary.main",
        overflow: "hidden",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        height: "40px",
        width: "100%",
      }}
      onClick={() =>
        !disabled &&
        onChange(isLeftSelected ? options.right.value : options.left.value)
      }
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
          backgroundColor: isLeftSelected ? "primary.main" : "transparent",
          color: isLeftSelected ? "white" : "primary.main",
          fontSize: "0.75rem",
          fontWeight: "medium",
          textTransform: "uppercase",
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor: isLeftSelected
              ? "primary.dark"
              : "rgba(25, 118, 210, 0.08)",
            color: isLeftSelected ? "white" : "primary.main",
          },
        }}
      >
        {options.left.label}
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
          backgroundColor: !isLeftSelected ? "primary.main" : "transparent",
          color: !isLeftSelected ? "white" : "primary.main",
          fontSize: "0.75rem",
          fontWeight: "medium",
          textTransform: "uppercase",
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor: !isLeftSelected
              ? "primary.dark"
              : "rgba(25, 118, 210, 0.08)",
            color: !isLeftSelected ? "white" : "primary.main",
          },
        }}
      >
        {options.right.label}
      </Box>
    </Box>
  );
};

export default TypeToggleButton;
